<div class="main-div">
  <div class="break"></div>
  <form
    [formGroup]="loginForm"
    (ngSubmit)="onSubmit()"
    class="example-form"
    autocomplete="off"
  >
    <mat-card class="card">
      <mat-card-title class="card-header">Timekeeper Login</mat-card-title>

      <mat-card-content>
        <div class="spacer"></div>
        <mat-form-field class="example-full-width">
          <mat-label>Your Name</mat-label>
          <input
            matInput
            formControlName="timekeeper_name"
            placeholder="Your Name - Ex. Bob"
            aria-autocomplete="list"
          />
          <mat-hint><strong>Enter your name</strong> </mat-hint>

          <mat-error> Your name is <strong>required</strong> </mat-error>
        </mat-form-field>
        <div class="spacer"></div>
        <mat-form-field class="example-full-width">
          <mat-label>System Generated PIN</mat-label>
          <input
            matInput
            formControlName="pin"
            placeholder="System Generated PIN, Ex. bghwy"
            aria-autocomplete="list"
          />
          <mat-hint
            >
              <strong>System generated PIN as found in the Race Director 
              Dashboard</strong><br /><p>
              <a href="../manual/#item-5-3" target="_blank" style="text-decoration: underline">Show me how</a></p>
          </mat-hint>

          <mat-error> The PIN is <strong>required</strong> </mat-error>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions
        ><div class="spacer"></div>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="black-button"
          (click)="goBeep()"
        >
          Login
        </button></mat-card-actions
      >
    </mat-card>
  </form>
  <div class="spacer"></div>
  <div class="link-footer">
    <a href="../time-event">
      <mat-icon
        aria-hidden="false"
        aria-label="Go back"
        class="mat-icon-style footer-icon"
        >arrow_back</mat-icon
      >
      <span class="footer-link-text">Back</span>
    </a>

    &nbsp;&nbsp;|&nbsp;&nbsp;

    <a href="../../" style="text-decoration: none">
      <mat-icon
        aria-hidden="false"
        aria-label="Homepage"
        class="mat-icon-style footer-icon"
        >home</mat-icon
      ><span class="footer-link-text">Home</span>
    </a>

    &nbsp;&nbsp;|&nbsp;&nbsp;

    <a href="../manual/#item-5-2" style="text-decoration: none" target="_blank">
      <mat-icon
        aria-hidden="false"
        aria-label="User Manual"
        class="mat-icon-style footer-icon"
        >menu_book</mat-icon
      ><span class="footer-link-text">User Manual</span>
    </a>
  </div>
  <div class="spacer"></div>
  <div class="link-version">
    <span>Version 5.00.00</span>
  </div>
</div>
<app-mat-spinner-overlay overlay="true" *ngIf="loading">
</app-mat-spinner-overlay>
